import CoreBase from '../../../services/engines/CoreBase';
import gatewayService from '../../../services/GatewayService';
import responseHelper from '../../../services/ResponseHelper';
import csCodeTemplateCache from './CsCodeTemplateCache';

const _name = 'CsCodeTemplateFetcher';
const TOPIC = 'Jerny.CsCodeTemplates';
const PAGE_SIZE = 50;

// Types that live in this topic and belong in the cache: code templates (title = strategyId)
// and the single CsCodeGenDefaults note (title = 'CsCodeGenDefaults').
const RELEVANT_TYPES = ['CsCodeTemplate', 'CsCodeGenDefaults'];

class CsCodeTemplateFetcher extends CoreBase {
    /**
     * Fetches all entries for the CsCodeTemplates topic.
     * Each CsCodeTemplate entry's title (e.g. "PluginClass", "DataDbContext") is the strategyId
     * used by CsCodeGenGenerator to look up the raw template body. The CsCodeGenDefaults entry
     * holds the form's default values as a JSON body.
     * @returns {object[]|null}
     */
    fetch = async () => {
        try {
            const resp = await gatewayService.getUserEntries(TOPIC, 1, PAGE_SIZE);
            if (responseHelper.check(resp, '', `${_name}.fetch`) < 0) {
                this.logError('fetch', `code: ${resp?.status}`);
                return [];
            }

            let items = resp.data.items ?? [];

            // only templates + defaults note, skip the index note
            items = items.filter((x) => x.stateId !== 999 && RELEVANT_TYPES.includes(x.type));

            csCodeTemplateCache.setCache(items);
        } catch (error) {
            this.logError('fetch', error.message);
            return [];
        }
    };
}

const csCodeTemplateFetcher = new CsCodeTemplateFetcher();
export default csCodeTemplateFetcher;
